import { useCallback, useState } from 'react'
import ReactDOM from 'react-dom'
import { useDispatch, useSelector } from 'react-redux'

import { fetchLienStatus } from '../../../../lib/fetchApi'
import { notificationActions } from '../../../../store/notifications'
import Button from '../../../common/Button'
import HoverWrapperInfo from '../../../wrappers/HoverWrapperInfo'

const FETCH_TITLE = 'Fetch status from county clerk?'
const FETCH_MESSAGE =
    'Ask GSCCCA for the latest clerk status for this lien. If the county has recorded it, book, page, and the recorded document will update automatically.'

const overlayStyle = {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1002,
}

const cardStyle = {
    backgroundColor: 'var(--background, var(--white, #fff))',
    borderRadius: 8,
    padding: '16px 20px',
    minWidth: 320,
    maxWidth: 'min(420px, 92vw)',
    boxShadow: '0 6px 20px rgba(0, 0, 0, 0.25)',
}

const titleStyle = { margin: '0 0 8px', fontSize: 16, fontWeight: 600 }
const textStyle = { margin: '0 0 16px', fontSize: 14, lineHeight: 1.45, color: 'var(--subtitle, #555)' }
const actionsStyle = { display: 'flex', justifyContent: 'flex-end', gap: 8, flexWrap: 'wrap' }

function FetchLienStatusConfirmModal({ onConfirm, onCancel }) {
    const overlayRoot = typeof document !== 'undefined' ? document.getElementById('overlay-root') : null
    if (!overlayRoot) {
        return null
    }

    return ReactDOM.createPortal(
        <div style={overlayStyle} role="presentation" onClick={onCancel}>
            <div
                style={cardStyle}
                role="dialog"
                aria-modal="true"
                aria-labelledby="lien-fetch-status-title"
                onClick={(e) => e.stopPropagation()}
            >
                <h3 id="lien-fetch-status-title" style={titleStyle}>{FETCH_TITLE}</h3>
                <p style={textStyle}>{FETCH_MESSAGE}</p>
                <div style={actionsStyle}>
                    <Button click={onCancel} btnStyle="btn_white">Cancel</Button>
                    <Button click={onConfirm}>Fetch status</Button>
                </div>
            </div>
        </div>,
        overlayRoot,
    )
}

export default function FetchLienStatus({ caseLienId, side }) {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [confirmOpen, setConfirmOpen] = useState(false)

    const userToken = useSelector((state) => state.user.token)
    const activeCase = useSelector((state) => state.case.activeCase)

    const runFetch = useCallback(async () => {
        setLoading(true)
        const response = await fetchLienStatus(
            userToken,
            activeCase.case.id,
            {
                case_lien_id: Number(caseLienId),
                side,
            },
            dispatch
        )
        setLoading(false)

        if (response && response.errorMessage) {
            dispatch(notificationActions.setError(response))
        } else {
            dispatch(notificationActions.setError({
                errorMessage: 'Lien status refreshed.',
                type: 'success',
            }))
        }
    }, [activeCase.case.id, caseLienId, dispatch, side, userToken])

    const handleConfirm = async () => {
        setConfirmOpen(false)
        await runFetch()
    }

    const handleCancel = () => {
        setConfirmOpen(false)
    }

    const openConfirm = () => {
        setConfirmOpen(true)
    }

    return (
        <>
            <HoverWrapperInfo modalText="Fetch status from county clerk">
                <Button
                    click={openConfirm}
                    isLoading={loading}
                    btnStyle="btn_small_icon"
                    title="Fetch status from county clerk"
                >
                    <i className="ti ti-refresh" />
                </Button>
            </HoverWrapperInfo>
            {confirmOpen ? (
                <FetchLienStatusConfirmModal onConfirm={handleConfirm} onCancel={handleCancel} />
            ) : null}
        </>
    )
}
